"use client";

import React from "react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
import { Scale, BookOpen, ScrollText } from "lucide-react";
export default function AvArbMuhammedCelik() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const educationData = [{
    degree: "Lisans",
    school: "Selçuk Üniversitesi Hukuk Fakültesi (2012 - 2016)",
    year: "",
    description: ""
  }, {
    degree: "Yüksek Lisans",
    school: "Süleyman Demirel Üniversitesi Sosyal Bilimler Enstitüsü, Avrupa Birliği Çalışmaları Ana Bilim Dalı",
    year: "",
    description: ""
  }];
  return <section id="av-arb-muhammed-çelik" ref={ref} className={cn("dark bg-gradient-to-br from-[#0a1128] via-[#121826] to-[#1c1c1c] text-foreground py-24 relative overflow-hidden transition-opacity duration-1000", isVisible ? "opacity-100" : "opacity-0")}>
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
          
          <div className="lg:col-span-5 relative group">
            <div className="relative overflow-hidden rounded-sm border border-border/20 bg-muted/10">
              <div className="aspect-[3/4] w-full relative">
                
                <div className="absolute inset-0 bg-primary/10 mix-blend-multiply z-10 pointer-events-none" />
                <img src="https://celikhukuk.net/wp-content/uploads/2026/03/Cubbe-Biyometrik.jpg" alt="Av. Arb. Muhammed Çelik" className="w-full h-full object-cover grayscale contrast-110 transition-all duration-700 group-hover:grayscale-0 group-hover:scale-105" />
              </div>
              
              
              <div className="absolute -bottom-6 -right-6 w-24 h-24 border-r-2 border-b-2 border-[#c5a059]/30 hidden md:block" />
              <div className="absolute -top-6 -left-6 w-24 h-24 border-l-2 border-t-2 border-[#c5a059]/30 hidden md:block" />
            </div>
          </div>

          
          <div className="lg:col-span-7 flex flex-col justify-center pt-4">
            <div className="mb-8">
              <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-medium tracking-tight mb-3 text-[#e2e2e2]">
                Av. Arb. Muhammed Çelik
              </h2>
              <p className="text-xl text-muted-foreground font-sans font-light tracking-wide flex items-center gap-2">Kurucu Avukat & Uzman Arabulucu & Bilirkişi</p>
            </div>

            <Tabs defaultValue="vision" className="w-full">
              <TabsList className="w-full justify-start bg-transparent border-b border-border/40 h-auto p-0 mb-8 gap-6 overflow-x-auto flex-nowrap">
                <TabsTrigger value="vision" className="border-b-2 border-transparent data-[state=active]:border-[#c5a059] data-[state=active]:bg-transparent data-[state=active]:text-[#c5a059] data-[state=active]:shadow-none px-0 py-3 text-base font-medium text-muted-foreground hover:text-foreground transition-colors">
                  Mesleki Vizyon
                </TabsTrigger>
                <TabsTrigger value="education" className="border-b-2 border-transparent data-[state=active]:border-[#c5a059] data-[state=active]:bg-transparent data-[state=active]:text-[#c5a059] data-[state=active]:shadow-none px-0 py-3 text-base font-medium text-muted-foreground hover:text-foreground transition-colors">
                  Eğitim
                </TabsTrigger>
                <TabsTrigger value="certifications" className="border-b-2 border-transparent data-[state=active]:border-[#c5a059] data-[state=active]:bg-transparent data-[state=active]:text-[#c5a059] data-[state=active]:shadow-none px-0 py-3 text-base font-medium text-muted-foreground hover:text-foreground transition-colors">
                  Sertifikalar & Üyelikler
                </TabsTrigger>
              </TabsList>

              
              <TabsContent value="vision" className="space-y-6 animate-in fade-in slide-in-from-bottom-4 duration-500">
                <div className="prose prose-invert max-w-none">
                  <p className="text-lg leading-relaxed text-muted-foreground font-sans">
                    Av. Arb. Muhammed Çelik Hukuk ve Arabuluculuk Bürosu, 2017 yılından bu yana Isparta merkezli olarak kesintisiz hukuki hizmet sunmaktadır. Mesleki pratiğimizin temelinde, müvekkil gizliliğine mutlak sadakat ve hukukun üstünlüğüne olan inanç yatmaktadır.
                  </p>
                  <p className="text-lg leading-relaxed text-muted-foreground font-sans mt-4">
                    Ceza Hukuku, Aile Hukuku ve Kurumsal Danışmanlık alanlarında derinleşen uzmanlığımızla, karmaşık hukuki süreçleri şeffaf, anlaşılır ve sonuç odaklı bir yaklaşımla yönetiyoruz. Amacımız, sadece hukuki ihtilafları çözmek değil, aynı zamanda önleyici hukuk hizmetleriyle müvekkillerimizin karşılaşabileceği riskleri minimize etmektir.
                  </p>
                </div>
                
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-6">
                  <div className="flex items-start gap-3 p-4 rounded-sm bg-muted/5 border border-border/10">
                    <Scale className="w-5 h-5 text-[#c5a059] mt-1 shrink-0" />
                    <div>
                      <h4 className="font-serif font-medium text-[#e2e2e2] mb-1">Adil Temsil</h4>
                      <p className="text-sm text-muted-foreground font-sans">Her müvekkil için tarafsız ve güçlü savunma ilkesi.</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3 p-4 rounded-sm bg-muted/5 border border-border/10">
                    <ScrollText className="w-5 h-5 text-[#c5a059] mt-1 shrink-0" />
                    <div>
                      <h4 className="font-serif font-medium text-[#e2e2e2] mb-1">Etik Değerler</h4>
                      <p className="text-sm text-muted-foreground font-sans">Avukatlık meslek kurallarına ve etiğine tam bağlılık.</p>
                    </div>
                  </div>
                </div>
              </TabsContent>

              
              <TabsContent value="education" className="space-y-6 animate-in fade-in slide-in-from-bottom-4 duration-500">
                <div className="space-y-6">
                  {educationData.map((edu, i) => <div key={i} data-index={i} className="flex gap-4 group">
                      <div className="flex flex-col items-center">
                        <div className="w-3 h-3 rounded-lg bg-[#c5a059]/20 group-hover:bg-[#c5a059] transition-colors mt-2" />
                        <div className="w-[1px] h-full bg-border/30 my-1 group-last:hidden" />
                      </div>
                      <div className="pb-6">
                        <h3 className="text-xl font-serif text-[#e2e2e2]">{edu.degree}</h3>
                        <div className="flex items-center gap-2 text-sm text-[#c5a059] font-medium mt-1 mb-2">
                          <BookOpen className="w-4 h-4" />
                          <span>{edu.school}</span>
                          {edu.year && <>
                            <span className="text-muted-foreground">•</span>
                            <span className="text-muted-foreground">{edu.year}</span>
                          </>}
                        </div>
                        {edu.description && <p className="text-muted-foreground leading-relaxed font-sans">
                          {edu.description}
                        </p>}
                      </div>
                    </div>)}
                </div>
              </TabsContent>

              
              <TabsContent value="certifications" className="animate-in fade-in slide-in-from-bottom-4 duration-500">
                <div className="space-y-8 py-2">
                  <div>
                    <h4 className="font-serif font-bold text-[#e2e2e2] text-xl mb-4">Resmi Sicil ve Ruhsatlar</h4>
                    <ul className="space-y-3 text-muted-foreground font-sans">
                      <li className="flex items-start gap-3">
                        <span className="text-[#c5a059] font-bold text-lg leading-none mt-1">•</span>
                        <span className="text-lg">Türkiye Barolar Birliği Avukatlık Ruhsatnamesi</span>
                      </li>
                      <li className="flex items-start gap-3"><span className="text-[#c5a059] font-bold text-lg leading-none mt-1" data-ast-id="f:/src/pages/Corporate/sections/AvArbMuhammedCelik.tsx|sig:k106or" data-ast-start="8652" data-ast-end="8729">•</span><span className="text-lg" data-ast-id="f:/src/pages/Corporate/sections/AvArbMuhammedCelik.tsx|sig:odpplz" data-ast-start="8754" data-ast-end="8823">Adalet Bakanlığı Arabuluculuk Daire Başkanlığı Arabuluculuk Belgesi</span></li>
                    </ul>
                  </div>

                  <div>
                    <h4 className="font-serif font-bold text-[#e2e2e2] text-xl mb-4">Uzman Arabuluculuk Yetkinlikleri</h4>
                    <ul className="space-y-3 text-muted-foreground font-sans">
                      <li className="flex items-start gap-3">
                        <span className="text-[#c5a059] font-bold text-lg leading-none mt-1">•</span>
                        <span className="text-lg">İş Hukuku Uzman Arabuluculuk</span>
                      </li>
                      <li className="flex items-start gap-3">
                        <span className="text-[#c5a059] font-bold text-lg leading-none mt-1">•</span>
                        <span className="text-lg">Ticaret Hukuku Uzman Arabuluculuk</span>
                      </li>
                      <li className="flex items-start gap-3">
                        <span className="text-[#c5a059] font-bold text-lg leading-none mt-1">•</span>
                        <span className="text-lg">Tüketici Hukuku Uzman Arabuluculuk</span>
                      </li>
                      <li className="flex items-start gap-3">
                        <span className="text-[#c5a059] font-bold text-lg leading-none mt-1">•</span>
                        <span className="text-lg">İnşaat Hukuku Uzman Arabuluculuk</span>
                      </li>
                      <li className="flex items-start gap-3">
                        <span className="text-[#c5a059] font-bold text-lg leading-none mt-1">•</span>
                        <span className="text-lg">Banka ve Finans Hukuku Uzman Arabuluculuk</span>
                      </li>
                      <li className="flex items-start gap-3">
                        <span className="text-[#c5a059] font-bold text-lg leading-none mt-1">•</span>
                        <span className="text-lg">Sigorta Hukuku Uzman Arabuluculuk</span>
                      </li>
                    </ul>
                  </div>

                  <div>
                    <h4 className="font-serif font-bold text-[#e2e2e2] text-xl mb-4">Bilirkişilik ve Nitelikli Hesaplama Uzmanlıkları</h4>
                    <ul className="space-y-3 text-muted-foreground font-sans">
                      <li className="flex items-start gap-3">
                        <span className="text-[#c5a059] font-bold text-lg leading-none mt-1">•</span>
                        <span className="text-lg">İş Mevzuatından Kaynaklı Nitelikli Hesaplamalar</span>
                      </li>
                      <li className="flex items-start gap-3">
                        <span className="text-[#c5a059] font-bold text-lg leading-none mt-1">•</span>
                        <span className="text-lg">Kat Mülkiyeti Mevzuatından Kaynaklı Nitelikli Hesaplamalar</span>
                      </li>
                      <li className="flex items-start gap-3">
                        <span className="text-[#c5a059] font-bold text-lg leading-none mt-1">•</span>
                        <span className="text-lg">Aktüerya (İş Göremezlik / Destekten Yoksun Kalma) Hesaplamaları</span>
                      </li>
                      <li className="flex items-start gap-3">
                        <span className="text-[#c5a059] font-bold text-lg leading-none mt-1">•</span>
                        <span className="text-lg">Trafik Kazaları ve Tazminat Hesaplamaları</span>
                      </li>
                    </ul>
                  </div>

                  <div>
                    <h4 className="font-serif font-bold text-[#e2e2e2] text-xl mb-4">Mesleki Eğitimler</h4>
                    <ul className="space-y-3 text-muted-foreground font-sans">
                      <li className="flex items-start gap-3">
                        <span className="text-[#c5a059] font-bold text-lg leading-none mt-1">•</span>
                        <span className="text-lg">CMK Eğitim Sertifikası</span>
                      </li>
                      <li className="flex items-start gap-3">
                        <span className="text-[#c5a059] font-bold text-lg leading-none mt-1">•</span>
                        <span className="text-lg">Adli Yardım Eğitim Sertifikası</span>
                      </li>
                      <li className="flex items-start gap-3">
                        <span className="text-[#c5a059] font-bold text-lg leading-none mt-1">•</span>
                        <span className="text-lg">Uzlaştırmacı Eğitimi</span>
                      </li>
                      <li className="flex items-start gap-3">
                        <span className="text-[#c5a059] font-bold text-lg leading-none mt-1">•</span>
                        <span className="text-lg">Kişisel Verilerin Korunması Kanunu (KVKK) Eğitimi</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </TabsContent>
            </Tabs>
          </div>
        </div>
      </div>
    </section>;
}